
export default function Banner(props) {
  return (
    <div className="banner">
      <h1>NO RULES SANDY</h1>
      <h1>({props.page})</h1>
    </div>
  );
}